export default __webpack_public_path__ + "static/media/yellow-pin.5b646e4a.png";